export default __webpack_public_path__ + "static/media/addition.b23ecb89.svg";